import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c9jvwne";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const headerProfileIsPhoneCss = "h1i5ufhe";
const headerProfileIsTabletUpCss = "hr0cxky";
const headerProfileCss = "hw6wf4t";
export const HeaderProfile = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isPhone = useDeviceType('isPhone');
  const isTabletUp = useDeviceType('isTabletUp');
  return <Component ref={ref} {...restProps} className={classNames(headerProfileCss, {
    [headerProfileIsPhoneCss]: isPhone,
    [headerProfileIsTabletUpCss]: isTabletUp
  }, props.className)} />;
});
const headerTitleCss = "h1atlejn";
export const HeaderTitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerTitleCss, props.className)} />;
});
const teamSizeContainerCss = "tzsu43i";
export const TeamSizeContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(teamSizeContainerCss, props.className)} />;
});

require("./owner_list_item.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./owner_list_item.js");